// src/utils/currency.js
const defaultOpts = {
  withSymbol: true,
  compact: false,
  minFractionDigits: 2,
  maxFractionDigits: 2,
  fallback: "-",
};

export function formatARS(value, opts = {}) {
  const {
    withSymbol,
    compact,
    minFractionDigits,
    maxFractionDigits,
    fallback,
  } = { ...defaultOpts, ...opts };

  if (value === null || value === undefined || value === "") return fallback;

  const normalized =
    typeof value === "string"
      ? (value.includes(",")
          ? Number(value.replace(/\./g, "").replace(",", "."))
          : Number(value))
      : Number(value);

  if (!Number.isFinite(normalized)) return fallback;

  const formatter = new Intl.NumberFormat("es-AR", {
    style: "currency",
    currency: "ARS",
    currencyDisplay: "symbol",
    minimumFractionDigits: minFractionDigits,
    maximumFractionDigits: maxFractionDigits,
    notation: compact ? "compact" : "standard",
    compactDisplay: "short",
  });

  const formatted = formatter.format(normalized);
  return withSymbol ? formatted : formatted.replace(/[^0-9.,\- \sKM]+/g, "").trim();
}

export function parseARS(input) {
  if (input === null || input === undefined) return null;
  if (typeof input === "number") return Number.isFinite(input) ? input : null;

  const cleaned = input
    .toString()
    .replace(/[^\d,.-]/g, "")
    .replace(/\./g, "")
    .replace(",", ".");

  const n = Number(cleaned);
  return Number.isFinite(n) ? n : null;
}
